import { ExpertServiceOngoingDto } from '../dtos';
import { ExpertServicesOngoing } from '../types/expertServiceOngoing';
import { mapper } from '../dtoMapper';

export function expertServicesOngoingAdapter(
  expertServicesOngoingDto: ExpertServiceOngoingDto[]
): ExpertServicesOngoing {
  return mapper(expertServicesOngoingDto);
}
